import React, { lazy } from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Your child cannot sit still for more than 5 minutes without grabbing a device', 'Homework time turns into a daily emotional war zone', 'Your child starts activities with excitement and quits before finishing', 'You feel guilty every time you hand over the iPad just to get some peace', 'Your child gets frustrated instantly when something feels too hard', 'You have tried everything and nothing seems to stick longer than a week', 'You worry your child is falling behind because they cannot concentrate at school', 'You spend your evenings searching Pinterest for activity ideas that never happen'];
  return <section className="bg-lightgray py-16 px-4 border-t border-border" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <div className="text-center mb-12" data-id="element-128">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-white mb-6 leading-tight" data-id="element-129">
            If you are a parent of a child between 3 and 12, you know this
            feeling all too well:
          </h2>
        </div>

        <div className="bg-navy rounded-2xl p-8 md:p-12 border border-white/10 shadow-sm" data-id="element-130">
          <ul className="space-y-5" data-id="element-131">
            <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0 * 0.06
          }} className="flex items-start" data-id="element-132">
              <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-133">✕</span>
              <span className="text-base md:text-lg text-ink font-medium" data-id="element-134">
                "Stolen" evenings watching your child disappear into a screen
                while you feel completely powerless to stop it.
              </span>
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 1 * 0.06
          }} className="flex items-start" data-id="element-135">
              <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-136">✕</span>
              <span className="text-base md:text-lg text-ink font-medium" data-id="element-137">
                Homework sessions that turn into emotional war zones — every
                single night.
              </span>
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 2 * 0.06
          }} className="flex items-start" data-id="element-138">
              <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-139">✕</span>
              <span className="text-base md:text-lg text-ink font-medium" data-id="element-140">
                The guilt of handing over the iPad just to get five minutes of
                peace.
              </span>
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 3 * 0.06
          }} className="flex items-start" data-id="element-141">
              <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-142">✕</span>
              <span className="text-base md:text-lg text-ink font-medium" data-id="element-143">
                Activity kits you bought with excitement that lasted exactly 3
                days before gathering dust on the shelf.
              </span>
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 4 * 0.06
          }} className="flex items-start" data-id="element-144">
              <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-145">✕</span>
              <span className="text-base md:text-lg text-ink font-medium" data-id="element-146">
                The quiet fear that your child is falling behind because they
                simply cannot concentrate at school.
              </span>
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 5 * 0.06
          }} className="flex items-start" data-id="element-147">
              <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-148">✕</span>
              <span className="text-base md:text-lg text-ink font-medium" data-id="element-149">
                Exhausting yourself searching Pinterest every Sunday for ideas
                that never happen.
              </span>
            </motion.li>
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-150">
          <p className="text-2xl md:text-3xl font-heading font-bold text-white italic" data-id="element-151">
            How many evenings have you lost feeling helpless — while their
            childhood slips by?
          </p>
        </div>
      </div>
    </section>;
}